module.exports = __webpack_public_path__ + "static/media/undraw_night_calls.7936c712.svg";